<template>
  <div class="bto-sb-widget bto-sb-widget-top-winnings">
    <div class="bto-sb-widget-title">
      <h3>{{t('Widget.LatestTopWinningsWidget')}}</h3>
      <!-- <timespan-selector-component/> -->
      <div class="bto-sb-form-select">
        <select v-model="selectedTimeframe" v-on:change='refresh()'>
          <option v-for="item in filter" :key="item.val" :value="item.val">
            {{t(item.label)}}
          </option>
        </select>
        <div class="bto-sb-form-select-arrow"></div>
      </div>
    </div>
    <div class="bto-sb-widget-content">
      <div class="bto-sb-top-winnings-nav">
        <span>{{t('Mobile.username')}}</span>
        <span>{{t('Mobile.Stake')}}</span>
        <span>{{t('Mobile.Winnings')}}</span>
      </div>
      <div class="bto-sb-top-winnings-content">
        <ul>
          <li v-for="(item, idx) in widgetData" :key="idx">
            <a href="javascript:void(0);" title="" @click="loadMyBetDetails(item.betslipId)">
              <span>{{item.username}}</span>
              <span>{{item.stake | formatAmountDisplay(item.currency, true)}}</span>
              <span>{{item.payout | formatAmountDisplay(item.currency, true)}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import TopWinningsRequestService from './service-top-winnings';
  import TopWinningsItemModel from './model-top-winnings';

  import WinningsDetailsRequestService from '../../../services/mybets/winnings-details-request-service';
  import MyBetDetailsModel from '../../../models/mybets/model-mybet-details';
  import { EventBus } from '../../../services/event-bus-service';

  export default {
    name: 'TopWinningsWidget',
    data() {
      return {
        selectedTimeframe: '7-days',
        widgetData: [],
        betDetails: {},
        winningsDetailsRequestService: new WinningsDetailsRequestService(),
        filter: [
          {val: '1-day', label: 'W.1day'},
          {val: '7-days', label: 'Widget.7days',},
          {val: '30-days', label: 'Widget.30days',},
        ],
      };
    },
    props: {
      defaultTimeframe: {
        fieldType: 'array',
        default: () => ['1-day', '7-day', '30-days'],
        selectedVal: '7-days',
        label: 'default value'
      },
      reverseFilter: {
        fieldType: 'Boolean',
        default: false,
        label: 'reverse filter order'
      },
    },
    created() {
      if(this.reverseFilter) {
        this.filter.reverse();
      }
      this.selectedTimeframe = typeof this.defaultTimeframe === 'string' ? this.defaultTimeframe : '7-days';
      this.getWidgetData();
    },
    methods: {
      getWidgetData() {
        let topWinningsService = new TopWinningsRequestService(this.selectedTimeframe);
        topWinningsService.execute((resp) => {
          this.widgetData = resp.data
            .map(datapoint => new TopWinningsItemModel(datapoint))
            .sort((a, b) => parseFloat(b.payout) - parseFloat(a.payout));
        }, () => {
          // pass
        });
      },
      refresh() {
        this.getWidgetData();
      },
      loadMyBetDetails(betId) {
        const expandedBet = this.widgetData.find(bet => bet.betslipId === betId);
        if (expandedBet) {
          const user = expandedBet.betslipId;
          const params = this.winningsDetailsRequestService.getParams;
          delete params.externalUserID;
          this.winningsDetailsRequestService.getParams = { ...params, betSlipGroupID: user };
          this.winningsDetailsRequestService.execute((response) => {
            this.betDetails = {};
            this.betDetails = new MyBetDetailsModel(response.data);
            EventBus.$emit('winnings-details', this.betDetails);
          }, () => {
          });
        }
      }
    },
  };
</script>
